import { render, staticRenderFns } from "./13.vue?vue&type=template&id=1bf04494&scoped=true&"
var script = {}
import style0 from "./13.vue?vue&type=style&index=0&id=1bf04494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf04494",
  null
  
)

export default component.exports